<template>
  <div class="animated fadeIn list-of-mb">
    <b-card>
      <div slot="header">Master Budget
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm" :disabled="disabledDelete">Delete</b-button>
          <b-button variant="primary mr-1" @click="print()"><i class="fa fa-print"></i> Print</b-button>
          <b-button variant="primary mr-1" @click="approvalConfirm()"><i class="fa fa-paper-plane"></i> Approval</b-button>
          <b-button variant="primary mr-1" @click="progress()"><i class="fa fa-hourglass-half"></i> Progress</b-button>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col md="6">
              <b-row>
                <b-col lg="8">
                  <b-input-group >
                      <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.uraian" ></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col  lg="4">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Budget No. &nbsp;</span></b-input-group-prepend>
                      <b-form-input v-model="tblData.nomor" placeholder="Budget No."></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>                      

            <b-input-group >
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
              </b-input-group>
        </b-col>
        <b-col md="6">
            <b-row>
              <b-col lg="8">
                  <b-input-group >
                    <b-input-group-prepend><label>Create Date</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="4">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Status &nbsp;</span></b-input-group-prepend>
                      <b-form-select v-model="tblData.status" :plain="true" :options="approvalStatus"></b-form-select>
                    </b-input-group>
                </b-col>
            </b-row>            
                    <b-input-group >
                      <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.customer" placeholder="Customer Name"></b-form-input>
                      <b-form-input v-model="tblData.cust_po" placeholder="Customer Order No." class="ml-1"></b-form-input>
                      <b-input-group-append>
                            <b-button variant="success" size="sm" @click="search()" class="ml-3"> <i class="fa fa-refresh"></i> Apply Filter</b-button>                
                      </b-input-group-append>
                      <b-input-group-append>
                            <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()" >Clear Filter</b-button>
                      </b-input-group-append>
                    </b-input-group>

        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#" style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item v-if="(data.item.send2wf == 1)" @click="rowEditDimension(data.item)" href="#" style="padding:0 !important;"><span>Edit Dimension</span></b-dropdown-item>
          <b-dropdown-item @click="rowPrint(data.item)" href="#"  style="padding:0 !important;">Print</b-dropdown-item>
          <b-dropdown-item @click="rowPost(data.item)" href="#" style="padding:0 !important;">Approval</b-dropdown-item>
          <b-dropdown-item @click="rowProgress(data.item)" href="#" style="padding:0 !important;">Progress</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;"> Delete</b-dropdown-item>
          <b-dropdown-item @click="rowAttachment(data.item)" href="#"  style="padding:0 !important;">Attachment</b-dropdown-item>
        </b-dropdown>
      </template>          

        <template v-slot:cell(tanggal)="data">
          {{ data.item.tanggal | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(startdate)="data">
          {{ data.item.startdate | moment("DDMMMYYYY") }} - {{ data.item.finishdate | moment("DDMMMYYYY") }}
        </template>
        <template v-slot:cell(nomorproduksi)="data">
          <div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis; max-width:150px !important;">
          {{ data.item.nomorproduksi }}</div>
        </template>
        <template v-slot:cell(issuccess)="data">
          <status-aprroval :dataStatus="data.item"></status-aprroval>  
        </template>
        <template v-slot:cell(budgettotal)="data">
          {{data.item.budgettotal | numFormat}}
        </template>
        <template v-slot:cell(budgettot_cash)="data">
          {{data.item.budgettot_cash | numFormat}}
        </template>
        <template v-slot:cell(budgettot_noncash)="data">
          {{data.item.budgettot_noncash | numFormat}}
        </template>
        <template v-slot:cell(budgetused)="data">
          {{data.item.budgetused | numFormat}}
        </template>
      </b-table>
      <b-row>
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="2" >
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
          </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
      <b-modal v-model="showApprovalConfirm" header-bg-variant="primary"  title="Approval Form" size="lg" :centered="true" hide-footer>
          <b-row>
              <b-col md="5">
                  <b-input-group>
                      <b-input-group-prepend><label>Budget Number</label></b-input-group-prepend>
                      <b-form-input v-model="model.nomor" readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col md="7">                            
                  <b-input-group>
                      <b-input-group-prepend><label>Budget Date</label></b-input-group-prepend>
                     <b-input-group-append ><label class="input-group-text">
                          {{ model.startdate | moment("DDMMMYYYY") }} - {{ model.finishdate | moment("DDMMMYYYY") }}                       
                       </label></b-input-group-append>                    
                  </b-input-group>
              </b-col>
          </b-row >  
          <b-row>
              <b-col md="9">
                  <b-input-group >
                      <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                      <b-form-input v-model="model.uraian"  placeholder="Budget Description" readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col md="3">
                  <b-form-checkbox :value="1" :unchecked-value="0" v-model="model.sales" disabled class="mt-1">Budget Sales/Project</b-form-checkbox>
              </b-col>
          </b-row>    
          <div v-if="(this.model.send2wf==1)">
            <label>Workflow process history</label>
            <div class="report-wraper">
                <table width="100%">
                <thead>
                <tr>
                <th width="120px">Assign Date</th>
                <th width="220px">Assign To</th>
                <th width="80px">Action Take</th>
                <th >Comment</th>
                <th width="120px">Complete Date</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="row in approvalHistory" :key="row.taskassignkey">
                  <td> {{row.assignstr | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                  <td>{{row.crewnik}} | {{row.crewname}}</td>
                  <td>{{row.actiontake}} 
                      <p v-if="(row.crewname !== row.actionBy)">{{row.actionBy}}</p></td>
                  <td>{{row.message}}</td>
                  <td><span v-if="(row.completeddate)">{{row.completeddate | moment("ddd DD-MMM-YYYY hh:mm:ss")}}</span></td>
                </tr>
                <tr> <td colspan="5" class="subtotal"></td></tr>
                </tbody>
                </table>
            </div>
            <b-row class="justify-content-center mt-1" >
                <b-button variant="primary" @click="printApproval"><i class="fa fa-print"></i> Print Approval</b-button>
                <b-button variant="success" class="ml-1" v-if="(model.iscomplete==1) && (model.issuccess==1)" @click="printOriginalBudget" > <i class="fa fa-print"></i> Original Approved Budget</b-button>
                <b-button variant="danger" class="ml-1" v-if="((model.iscomplete==0) || (model.isreject==1) || (approvalHistory.length==0))" @click="showApprovalCancelConfirm=true" > <i class="fa fa-undo"></i> Cancel Approval</b-button>
                <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
            </b-row>
        </div>
        <div no-body v-else>
          <label>Add Attachment</label>
            <b-form-file
            v-model="file"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            ></b-form-file>
            <div class="mt-3" >Selected file: <strong>{{ file ? file.name : '' }}</strong></div>   
            <b-row class="justify-content-center mt-1" v-if="(showConfirmNoFile)">
                <label style="width:260px !important;">Send without attachment, are you sure?</label>
                  <b-form-radio-group  v-model="confirmNoFile"  class="ml-1" >
                      <b-form-radio :value="true">Yes</b-form-radio>
                      <b-form-radio :value="false">No</b-form-radio>
                  </b-form-radio-group>
            </b-row>
            <b-row class="justify-content-center mt-1" >
                <b-button variant="primary" @click="approval"><i class="fa fa-paper-plane"></i> Send to Workflow</b-button>
                <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
            </b-row>
        </div>
      </b-modal>
      <b-modal v-model="showApprovalCancelConfirm" title="Remove from workflow Approval Process?" :centered="true" @ok="approvalUndo">
        <p class="mb-1">The selected a row of data will be removed from Workflow?</p>
      </b-modal>

      <b-modal v-model="showAttachment" header-bg-variant="primary"  title="Attachment" size="lg" :centered="true" ok-only>
            <b-row>
                <b-col lg="6">
                    <b-input-group>
                        <b-input-group-prepend><label>Budget No.</label></b-input-group-prepend>
                        <b-form-input v-model="model.nomor" readonly></b-form-input>
                    </b-input-group>
                </b-col>
            </b-row >    
            <div class="report-wraper">
              <table width="100%">
                <thead>
                  <tr>
                    <th width="200px">Attached Date</th>
                    <th >File Name</th>
                    <th width="100px">Attached By</th>
                    <th width="40px">action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in attachmens" :key="row.attachmentKey">
                    <td> {{row.modified | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                    <td>                                
                        <b-link @click="attachmentDownload(row)">{{row.attchFileNm}}</b-link>
                    </td>
                    <td>{{row.createby}}</td>
                    <td>                                
                      <div class="text-center" v-if="(model.iscomplete==0)">
                          <a href="javascript:void(0)" class="text-danger" @click="delAttachment(row)">
                              <i class="fa fa-trash"></i>
                          </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          <div no-body v-if="(model.iscomplete==0)">
            <label>Add Attachment</label>
              <b-form-file
              v-model="file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              ></b-form-file>
              <b-row class="mt-1" >
                  <span class="p-2" >Selected File: <strong>{{ file ? file.name : '' }}</strong> Filesize:{{bytesToKB.showFileSize(file)}}</span>   
                  <b-button variant="success" @click="attachmentSave" class="sm" v-if="(file)"><i class="fa fa-paperclip"></i> Add Attachment</b-button>
              </b-row>
          </div>
      </b-modal>
      <b-modal
        v-model="showEditDimension"
        header-bg-variant="primary"
        title="Update Dimension"
        size="md"
        :centered="true"
        :hide-footer="true"
      >
        <b-row>
          <b-col md="12">
            <b-input-group class="mb-2">
              <b-input-group-prepend><label style="width:130px; padding-top:5px;">Budget Number</label></b-input-group-prepend>
              <b-form-input v-model="model.nomor" readonly></b-form-input>
            </b-input-group>
            <v-dim :model="model" :key="updateDimHdr"></v-dim>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mt-3">
          <b-button variant="primary" class="mr-1" @click="saveDimension">
            <i class="fa fa-save"></i> Save Dimension
          </b-button>
          <b-button variant="secondary" @click="showEditDimension = false">
            <i class="fa fa-close"></i> Close
          </b-button>
        </b-row>
      </b-modal>
  </div>
</template>

<style lang="scss">
  .list-of-mb {
      table {
        td:nth-child(1) {
          width: auto;
        }
        td:nth-child(2) {
          width: auto;
        }
        td {
          .dropdown-item {
              padding: 0.1rem 1.5rem !important;
              font-size: smaller !important;
          }    
        }
      }
     }
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import budgetproduksi from "../../apis/budgetproduksi";
import dimensionApi from "../../apis/dimension";
import task from "../../apis/task";
import dropdown from "../../data/dropdown";
import bytesToKB from '../../libs/filesize-byte2kb';
import toastr from "mini-toastr";
import vDim from "../lookup/dim";
import { validationMixin } from "vuelidate";
import { required} from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { Loading, vDim },
  mixins: [validationMixin],
  validations: {
        closeVoidData: {
            closevoidnote: { required },
        },
  }, 
  data() {
    return {
      showFilter: false,
      showDelConfirm: false,
      showApprovalConfirm: false,
      showConfirmNoFile:'',
      confirmNoFile:false,
      showApprovalCancelConfirm: false,
      showApproval:false,
      approvalHistory:[],    
      approvalStatus : dropdown.approvalStatus,
      file:null,
      showAttachment: false,
      showEditDimension: false,
      updateDimHdr: false,
      attachmens: [],
      bytesToKB,
      disabledDelete:false,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      tblData: {
        status:"",
        postgroup:"",
        page: 1,
        limit: 15,
        total: 0,
        
        tgl1:this.$store.state.user.tglaktif,
        tgl2:moment().format('YYYY-MM-DD'),
        sortBy: 'nomor',
        sortDesc: true,
        DimCol:'Dim1',
        outstand:''
      },
      items:[],
      model:{},
      postGroups:[],
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    
    tblFields(){
      const fields=[
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
          {
            key: "nomor",
            thStyle: "width:120px",
            label: "Budget Number",
            sortable: true
          },
          {
            key: "tanggal",
            thStyle: "width:90px",
            label: "Create Date",
            sortable: true
          },
          {
            key: "uraian",
            thStyle: "width:300px",
            label: "Budget Name",
          },
          {
            key: "lokasi",
            label: "Production Location",
            sortable: true
          },
          {
            key: "jmlproduksi",
            thStyle: "width:70px",
            label: "QTY Production",
            sortable: true
          },
          {
            key: "nomorproduksi",
            label: "No.Product/Eps.",
            sortable: true
          },

          {
            key: "startdate",
            thStyle: "width:100px",
            label: "Production Period",
            sortable: true
          },
          // {
          //   key: "budgettot_cash",
          //   label: "Budget Cash",
          //   thStyle: "width:100px",
          //   thClass: "text-right",
          //   tdClass: "text-right",
          //   sortable: true
          // },
          // {
          //   key: "budgettot_noncash",
          //   label: "Budget NonCash",
          //   thStyle: "width:100px",
          //   thClass: "text-right",
          //   tdClass: "text-right",
          //   sortable: true
          // },
        {
          key: "budgettotal",
          label: "Budget Total",
          thStyle: "width:100px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "budgetused_tot",
          label: "Actual Used",
          thStyle: "width:100px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
          {
            key: "issuccess",
            thStyle: "width:120px",
            label: "Approval Status",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },

        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: `${dims[i].value}Txt`,
            // thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }
      return fields;
    },
    dimCol() {
        return this.tblData.DimCol;
    },
    invalidCloseVoidData() {
      this.$v.closeVoidData.$touch();
      return this.$v.closeVoidData.$invalid;
    },
  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
  },
  // created: async function(){
      // const accList = await budgetproduksi.postgroup();
      // this.postGroups = accList.reduce((newArr,item) =>{
      //       newArr.push(item);
      //       return newArr;
      //   },[{ value: '', text: '--- ALL ---'}]);
        // const now = new Date();
        // const tgl1 = moment(now).startOf('month').format('YYYY-MM-DD');
        // const tgl2 = moment(now).endOf('month').format('YYYY-MM-DD');
        // this.tblData.tgl1=this.tblData.tgl1 || tgl1;
        // this.tblData.tgl2=this.tblData.tgl2 || tgl2;
  // },  
  methods: {
    // onFiltered(filteredItems) {
    //   this.tblData.total = filteredItems.length;
    // },
    data: async function(ctx) {
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.mblist) {
            this.tblData[key] = filter.mblist[key];
            filtered=true;
        }
        if (filtered === true) {
          this.tblData.tgl1=filter.mblist.tgl1 || '';
          this.tblData.tgl2=filter.mblist.tgl2 || '';
          this.showFilter=filtered;
          delete filter.mblist;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.isLoading=true;
      const list = await budgetproduksi.list(this.tblData); 
      this.items = list;  
      this.isLoading=false;

      return list;
    },
    search() {
      this.tblData.page=1;
      this.refresh();
    },     
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.customer=  '';
        this.tblData.cust_po=  '';
        this.tblData.status=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';

    },
    saveFilter() {
      const keys = ['uraian', 'nomor', 'DimCol', 'DimColInfo', 'DimVal', 'tgl1', 'tgl2', 'customer', 'cust_po', 'status', 'jmlproduksi'];
      let filtered = false;
      const mblist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              mblist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          mblist.page=this.tblData.page;
          mblist.limit=this.tblData.limit;
          mblist.sortBy=this.tblData.sortBy;
          mblist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.mblist=mblist;
          this.$store.commit("filter", filter);
      }
    },    
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowEditDimension(record) {
      this.model = Object.assign({}, record);
      this.dimension.forEach((dim) => {
          if (this.model[dim.value]) {
              this.model[`${dim.value}Info`] = this.model[dim.value] + ' | '+ this.model[`${dim.value}Txt`];
          }
      });
      this.showEditDimension = true;
      setTimeout(() => {
          console.log('this.model: ',this.model);
          this.updateDimHdr = !this.updateDimHdr;    
      }, 100);
    },
    saveDimension: async function() {
      try {
        this.model.TableName = 'project_budget_header';
        const dimValResult = await dimensionApi.validate(this.model);
        if (!dimValResult.success) {
          const msg = dimValResult.message || 'Dimension validation error';
          toastr.error(msg, "ERROR MESSAGE");
          return;
        }
        this.isLoading = true;
        await budgetproduksi.saveDimension(this.model);
        toastr.success("Dimension updated successfully", "Update Dimension");
        this.showEditDimension = false;
        this.isLoading = false;
        this.refresh();
      } catch (error) {
        this.isLoading = false;
        if (error.sql) {
          toastr.error(error.sql, 'ERROR MESSAGE', 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, 'ERROR MESSAGE', 10000);
        } else if (error.message) {
          toastr.error(error.message, 'ERROR MESSAGE', 10000);
        } else {
          toastr.error(JSON.stringify(error), 'ERROR MESSAGE', 10000);
        }
      }
    },
    rowPost(record) {
      this.rowClicked(record);
        this.approvalConfirm();        
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.print();        
    },
    rowProgress(record) {
      this.rowClicked(record);
        this.progress();        
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();

    },    
    rowAttachment(record) {
      this.model = record;
      this.getAttachment(record);
    },
    getAttachment: async function(record) {
      try {
        this.model = record;
        this.isLoading=true;
        const data = await task.getAttachment({taskkey: record.pjxhdrkey});
        this.attachmens=data;    
        this.showAttachment=true;            
        this.isLoading=false;
      } catch (error) {
        this.isLoading=false;
        console.log('error : ', error);
        if (error.sql) {
            toastr.error(error.sql,'ERROR MESSAGE',10000);
        } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
        } else if (error.message) {
            toastr.error(error.message,'ERROR MESSAGE',10000);
        } else {
            toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
        }   
      }
    },    
    attachmentSave : async function(evt) {
          evt.preventDefault()
          if (!this.file) {
              toastr.error('Please choose a file');
        } else {
            toastr.info(`Attachment Save`);
            this.isLoading=true;
            try {
                const formData = new FormData();
                formData.append('file', this.file);
                formData.append('filename', this.file.name);
                formData.append('tablekey', this.model.pjxhdrkey);
                formData.append('tableName', 'project_budget_header');
                formData.append("filesize", bytesToKB.showFileSize(this.file));
                const response = await task.attachmentSave(formData);
                console.log('response : ',response);
                const data = await task.getAttachment({taskkey: this.model.pjxhdrkey});
                this.attachmens=data;    
                this.file=null;
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
            }
        }
    },   
    attachmentDownload : async function(fl) {
        this.isLoading=true;
        try {
            await task.attachmentDownload(fl);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            console.log('error : ', error);
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }   
        }
    },      
    delAttachment : async function(obj) {
      const pesan=`Do You realy want to delete the attachment "${obj.attchFileNm}"?`;
      this.$bvModal.msgBoxConfirm(pesan, {
      title: 'Please Confirm',
      size: 'sm',
      buttonSize: 'sm',
      okVariant: 'success',
      okTitle: 'YES',
      cancelTitle: 'NO',
      footerClass: 'p-2',
      hideHeaderClose: false,
      centered: true
      })
      .then(async(value) => {
          if (value==true){
              this.isLoading=true;
                try {
                    await task.delAttachment(obj);
                  const data = await task.getAttachment({taskkey: this.model.pjxhdrkey});
                  this.attachmens=data;    
                    this.isLoading=false;    
                } catch (error) {
                    this.isLoading=false;
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
                }
          }
      })
      .catch(err => {
      })                
    },

    add(){
      this.saveFilter();
          router.push({name :'budget.mstrbudgetfrm'});
    },
    edit: function() {
        if (this.model.pjxhdrkey) {
          this.saveFilter();
          router.push({name :'budget.mstrbudgetfrm', params: { pjxhdrkey: this.model.pjxhdrkey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model.pjxhdrkey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await budgetproduksi.remove(this.model);
        // const index= this.items.findIndex(r => (r.pjxhdrkey==this.model.pjxhdrkey));
        // this.items.splice(index, 1);
        this.refresh();
      } catch (error) {
        this.isLoading=false;
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },
    rowClicked(record, index) {
      if( record.status === '111' ){
        this.disabledDelete = true;
        // this.disabledCloseVoid   = false;
      }else{
        this.disabledDelete = false;
        // this.disabledCloseVoid   = true;
      }

      // if (this.model.pjxhdrkey == record.pjxhdrkey) {
      //     this.edit();
      // } else {
        if ((this.model) && (this.model._rowVariant)) {
            delete this.model._rowVariant;
        }
        this.model = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
      // }
    },
    approvalConfirm: async function () {
        if (this.model.pjxhdrkey) {
                this.showApprovalConfirm = true;
            if (this.model.send2wf==1) {
              try {
                const data = await task.approvalhistory({key: this.model.pjxhdrkey});
                this.approvalHistory=data;                
              } catch (error) {
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }                
              }
            }
            this.model.tanggal = this.model.tanggal ? moment(this.model.tanggal).format('YYYY-MM-DD') : '';
        } else {
            toastr.warn('Please select a row that want to be sent to workflow Approval!');
        }
    }, 
    approval: async function(evt){
        evt.preventDefault()
        try {
            const formData = new FormData();
            if (!(this.file)) {
              if (this.confirmNoFile==false){
                toastr.info('Send without attachment, are you sure?');
                this.showConfirmNoFile=true;
                return;
              }
            } else {
              formData.append('file', this.file);
              formData.append('filename', this.file.name);
            }
            formData.append('tablekey', this.model.pjxhdrkey);
            this.showApprovalConfirm = false;
            this.isLoading=true;
            const resp = await budgetproduksi.approval(formData);
            this.model.send2wf=1;
            this.refresh();
            this.isLoading=false;
            if (resp.message) {
                toastr.warn(resp.message,'warning',10000);
            }
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    approvalUndo: async function(){
        this.isLoading=true;
        try {
            await budgetproduksi.approvalUndo(this.model);
            this.model.send2wf=0;
            this.showApprovalConfirm = false;
            this.refresh();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    printApproval: async function()
    {
      if (this.model.pjxhdrkey) {
          try {
                this.showReport=true;
              this.reportUrl= await task.approvalprint({key: this.model.pjxhdrkey});
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },    
    printOriginalBudget: async function()
    {
      if (this.model.pjxhdrkey) {
          try {
                this.showReport=true;
              this.reportUrl= await budgetproduksi.printOriginalApprovedBefore(this.model);
              if (this.$isMobile()){
                  this.showReport=false;            
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },    
    print: async function()
    {
      if (this.model.pjxhdrkey) {
          try {
                this.showReport=true;
              this.reportUrl= await budgetproduksi.print(this.model);
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    progress: async function()
    {
        if (this.model.pjxhdrkey) {
          if ((this.model.iscomplete==1) && (this.model.issuccess==1)) {
              const filter = this.$store.state.filter;
              filter.mblist=this.tblData;
              this.$store.commit("filter", filter);
              router.push({name :'budget.progressmstrbudget', params: { pjxhdrkey: this.model.pjxhdrkey}});
          } else {
            toastr.warn('Approval in Progress, no transaction/requesition for the budget !');
          }
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await budgetproduksi.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    close(){
        // router.push({name:'budgetproduksiment.home'});
          router.push("home");
    },
  }
};
</script>
